import React from "react";
import AnchorHeading from "../anchor-heading";

export default function SectionDefault(props) {
  return (
    <section
      id={props.id}
      className="uk-section-small uk-section-default uk-border-rounded uk-box-shadow-medium uk-margin-bottom"
    >
      <div className="uk-padding-large uk-padding-remove-top uk-padding-remove-bottom">
        {props.heading && (
          <div className="uk-text-center">
            <h1 className="page-title">{props.heading}</h1>
          </div>
        )}
        {props.subheading && (
          <h2 className="uk-margin-remove-top uk-heading-divider">
            <AnchorHeading heading={props.subheading} />
          </h2>
        )}
        {props.subheadingNoBrdr && (
          <h2 className="uk-margin-remove-top">
            <AnchorHeading heading={props.subheadingNoBrdr} />
          </h2>
        )}
        {props.subheading2 && (
          <h3 className="uk-heading-divider uk-margin-remove-bottom">
            <AnchorHeading heading={props.subheading2} />
          </h3>
        )}
        {props.children}
      </div>
    </section>
  );
}
